import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/motion.stylex';
import { motion } from '@tokens/motion.stylex';

// Bare select styled like the prototype `.input` (compose with <Field> for label/hint).
export const styles = {
  select: {
    kZKoxP: "x16wdlz0",
    kzqmXN: "xh8yej3",
    kWkggS: "xvys5x3",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1xo1f5v",
    kaIpWk: "xxltkoq",
    kE3dHu: "x22nqq9",
    kpe85a: "x10d1yod",
    kMwMTN: "x1oezkus",
    kMv6JI: "xdv2sak",
    kGuDYH: "x2pyw9z",
    kI3sdo: "x1a2a7pz",
    kkrTdU: "x1ypdohk",
    kysU6D: "xjyslct",
    kKwaWg: "x8ord10",
    kz484i: "xiy17q3",
    k1YJky: "xva6ddr",
    kmkexE: "x1k3q35m",
    k4mVRr: "xwo1ljg",
    kWEjV4: "xs8x3o8",
    kL3a3j: "xxgwfau",
    kWCcOm: "xfqoyci",
    kYPGJ8: "x1s07b3s",
    $$css: true
  },
  invalid: {
    kVAM5u: "x1vgqim1",
    k4mVRr: "x1x16wwa",
    kWEjV4: "x10li9c4",
    $$css: true
  }
};